import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function Timesheets() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/timesheets").then((r) => setRows(r.data)); }, []);
  const badgeFor = (s) =>
    s === "approved" ? "bg-emerald-50 text-emerald-700 border-emerald-200" :
    s === "pending" ? "bg-amber-50 text-amber-700 border-amber-200" :
    "bg-indigo-50 text-indigo-700 border-indigo-200";
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-1">Time & Attendance</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Timesheets</h1>
      </div>
      <Card className="border-border shadow-none overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Employee</TableHead>
              <TableHead>Week</TableHead>
              <TableHead className="text-right">Hours</TableHead>
              <TableHead className="text-right">Billable</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((t) => (
              <TableRow key={t.id}>
                <TableCell className="font-medium">{t.employee}</TableCell>
                <TableCell className="font-mono text-sm">{t.week}</TableCell>
                <TableCell className="text-right font-mono">{t.hours}h</TableCell>
                <TableCell className="text-right font-mono">{t.billable}h</TableCell>
                <TableCell><Badge className={`${badgeFor(t.status)} hover:opacity-90 capitalize`}>{t.status}</Badge></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
